export default __webpack_public_path__ + "static/media/edit.1d4893a7.svg";